import React from "react";
import PropTypes from "prop-types";

import _ from "lodash";
import Modal from "react-modal";

import Button from "../Button/Button.jsx";
import SvgIcon from "../Icon/SvgIcon.jsx";

import "./styles/index.scss";

const UModal = ({ isOpenModal, isUpper, modalTitle, size, closeModal, ...rest }) => {
  /**
   * Вернуть класс, применяемый для размера кнопки
   *
   * @param {String} value
   * @return {String}
   */
  const getSizeClass = value => {
    const classes = {
      lg: "modal-content--lg",
      md: "modal-content--md",
      sm: "modal-content--sm",
      xs: "modal-content--xs",
    };

    return _.get(classes, value, Button.defaultProps.size);
  };

  const overlayClassNames = ["modal-overlay", isUpper && "modal-overlay--upper"]
    .filter(name => name)
    .join(" ");

  const classNames = ["modal-content", getSizeClass(size), rest.className]
    .filter(name => name)
    .join(" ");

  return (
    <Modal
      isOpen={isOpenModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      parentSelector={() => document.getElementById("app")}
      bodyOpenClassName={null}
      portalClassName="modal-portal"
      overlayClassName={overlayClassNames}
      className={classNames}
    >
      <div className="modal-content__header">
        <div className="modal-content__header-title">{modalTitle}</div>
        <Button icon="only" paddingOff="all" onClick={closeModal}>
          <SvgIcon name="close" />
        </Button>
      </div>
      <div className="modal-content__content">{rest.children}</div>
    </Modal>
  );
};

UModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  isUpper: PropTypes.bool,
  modalTitle: PropTypes.string,
  size: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
};

UModal.defaultProps = {
  isUpper: false,
  modalTitle: "Подтвердите действие",
  size: "sm",
};

export default UModal;
